import { render, staticRenderFns } from "./SearchTalent.vue?vue&type=template&id=48c3cdb7&scoped=true"
import script from "./SearchTalent.vue?vue&type=script&lang=js"
export * from "./SearchTalent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SearchTalent.vue?vue&type=style&index=1&id=48c3cdb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c3cdb7",
  null
  
)

export default component.exports